import { combineReducers, configureStore } from '@reduxjs/toolkit';
import playgroundsReducer from './playgrounds';
import centersReducer from './centers';
import meetingsReducer from './meetings';
import authReducer from './auth';
import userReducer from './user';

const rootReducer = combineReducers({
  playgrounds: playgroundsReducer,
  centers: centersReducer,
  meetings: meetingsReducer,
  auth: authReducer,
  user: userReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
        // Игнорируем большие объекты в состоянии для dev режима
        ignoredActionPaths: ['payload'],
        ignoredPaths: ['playgrounds.items', 'centers.items', 'meetings.items'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

